export const type_nutrition = 'nutrition';
export const type_trials = 'trials';
